import axiosInstance from "./axiosInstance";

// 查询今日剩余预约数
export function getTodayNumber() {
	return axiosInstance.get('/reservation/getTodayNumber')
}
// 查询是否存在已预约无结果
export function getIsNoOver(phone) {
	return axiosInstance.get('/reservation/getIsNoOver?phone='+phone)
}
// 查询总预约数
export function getTotalNumber(phone) {
	return axiosInstance.get('/reservation/getTotalNumber?phone='+phone)
}
// 查询预约调理
export function getIsNoOverConditioning(phone) {
	return axiosInstance.get('/reservation/getIsNoOverConditioning?phone='+phone)
}
//注册
export function addUser(param) {
	return axiosInstance.post('/reservation/addUser', param)
}
//登陆
export function login(param) {
	return axiosInstance.post('/reservation/login', param)
}
//预约
export function reservation(param) {
	return axiosInstance.post('/reservation/reservation', param)
}
//预约调理
export function conditioning(param) {
	return axiosInstance.post('/reservation/conditioning', param)
}
//获取验证码
export function sms(mobile) {
	return axiosInstance.get('/reservation/sms?mobile='+mobile+'&status=1')
}
//查询最近一次检测结果
export function getResult(phone) {
	return axiosInstance.get('/reservation/getResult?phone='+phone)
}
//填写反馈
export function addFeedBack(phone,content) {
	return axiosInstance.get('/reservation/addFeedBack?phone='+phone+'&content='+content)
}
//重置密码
export function forgetPassword(phone,code,pass) {
	return axiosInstance.get('/reservation/forgetPassword?phone='+phone+'&code='+code+'&password='+pass)
}
